<template>
  <Component :is="typeof $route.meta.layout === 'function' ? $route.meta.layout() : $route.meta.layout">
    <RouterView />
  </Component>
  <AiAssistantWidget v-if="showAiAssistantWidget" />
  <HelpModal />
  <WLoading />
  <ConfirmationPane />
  <WTooltip />
  <SdfAlertToastContainer />
  <MaintenanceBanner />
</template>

<script setup lang="ts">
import ConfirmationPane from '@pequity/shared/components/confirmation-pane/confirmation-pane.vue';
import { useHelpStore } from '@pequity/shared/stores/help';
import { SdfAlertToastContainer, WLoading, WTooltip } from '@pequity/shared/ui';
import { defineAsyncComponent } from 'vue';
import AiAssistantWidget from '@/ai-assistant/components/ai-assistant-widget/ai-assistant-widget.vue';
import { useAiAssistantWidget } from '@/ai-assistant/composables/useAiAssistantWidget';
import MaintenanceBanner from '@/components/maintenance-banner/maintenance-banner.vue';
import { useIdleSessionTimeout } from '@/composables/useIdleSessionTimeout';
import { useOidcIdleGuard } from '@/composables/useOidcIdleGuard';

defineOptions({
  name: 'App',
});

// Data
const helpStore = useHelpStore();
const { showAiAssistantWidget } = useAiAssistantWidget();
useIdleSessionTimeout();
useOidcIdleGuard();

// Async components
const HelpModal = defineAsyncComponent(async () => {
  helpStore.loading = true;
  const helpModal = await import('@pequity/shared/help/components/help-modal.vue');
  helpStore.loading = false;

  return helpModal;
});
</script>
